export const modifierKeys = {
  all: ['skuModifiers'],
  groups: venueId => [...modifierKeys.all, 'groups', venueId],
};
